
import React from 'react';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

const SmartMeterTableHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Device ID</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Battery</TableHead>
        <TableHead>Signal</TableHead>
        <TableHead>Last Communication</TableHead>
        <TableHead>Alerts</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default SmartMeterTableHeader;
